import Icon from "@mui/material/Icon";
import dayjs from "dayjs";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

type Props = {
  row: any;
  onToggleDateGroup: (dateKey: string) => void;
  onToggleUserGroup: (userId: string) => void;
};

const formatHoursFromSeconds = (seconds: number) => {
  const totalSeconds = Math.max(0, Math.floor(seconds || 0));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

const getSummaryText = (row: any) => {
  const totalHours = formatHoursFromSeconds(row.groupTotalTimeTrackedSeconds ?? 0);
  const entryLabel = row.groupCount === 1 ? "entry" : "entries";
  return `${totalHours} total • ${row.groupCount} ${entryLabel}`;
};

export default function TimeEntriesGroupHeader({
  row,
  onToggleDateGroup,
  onToggleUserGroup,
}: Props) {
  return (
    <MDBox
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      py={0.5}
      px={1}
      sx={{
        backgroundColor: row.groupType === "user" ? "#ebeff3" : "#f4f6f8",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        cursor: "pointer",
      }}
      onClick={() => {
        if (row.groupType === "user") {
          onToggleUserGroup(row.groupUserId);
          return;
        }

        onToggleDateGroup(row.groupDateKey);
      }}
    >
      <MDBox display="flex" alignItems="center" gap={1}>
        <Icon fontSize="small">{row.groupCollapsed ? "chevron_right" : "expand_more"}</Icon>
        <MDTypography variant="button" fontWeight="bold" color="dark">
          {row.groupType === "user" ? row.groupUserName : dayjs(row.groupForDate).format("ddd, MMMM D, YYYY")}
        </MDTypography>
      </MDBox>
      <MDTypography variant="caption" color="secondary" fontWeight="bold">
        {getSummaryText(row)}
      </MDTypography>
    </MDBox>
  );
}
